import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_footwear_women: FaireCategoryEntity = {
  token: "cat_footwear-women",
  type: "category",
  name: "Women",
  level: 2,
  parentToken: "cat_footwear",
  href: "/category/footwear/women",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
